import { CerDataImportFile, ICerDataImportFile, IDataImportFileReader } from './cer-data-import-types';

export class CerDataImportRow {
  constructor(rowData: any) {
    this.rowData = rowData
  }

  public rowData: any;
}
export class CerExcelColumn {
  constructor(title: string, name: string = null, index: string = null) {
    this.title = title;
    this.name = name;
    this.index = index;
  }

  public title: string;
  public name?: string;
  public index?: string;
}
export class CerExcelSheet {
  constructor(
    public workbook: CerExcelWorkbook,
    public name: string) {
  }

  public columns: CerExcelColumn[] = [];
  public rows: CerDataImportRow[] = [];
}

export class CerExcelWorkbook implements ICerDataImportFile {
  //static construct(file: CerPasteFile): CerExcelWorkbook {
  //  return Object.assign(new CerExcelWorkbook(),file);
  //}
  public name: string;
  public type: string;
  public size: number;
  public lastModified: Date;
  public status: 'error' | 'ok';
  public statusText?: string;

  public sheets: CerExcelSheet[] = [];
  public fieldMap: Map<string, string>;
  public rowCountTotal: number = 0;
}

class CerNextIndex {
  public index1: number;
  public index2: number;
}

export class CerDataImportExcelReader implements IDataImportFileReader {
  public static legalMimeTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel'
  ];

  public async read(buffer: ArrayBuffer, pasteFile: CerDataImportFile): Promise<CerDataImportFile> {
    const wb = Object.assign(new CerExcelWorkbook(), pasteFile);
    await CerDataImportExcelReader.readExcelXslx(buffer, wb);
    CerDataImportExcelReader.setStatus(wb);
    return wb;
  }

  public static async readExcelXslx(buffer: ArrayBuffer, cerWb: CerExcelWorkbook): Promise<boolean> {
    const xlsx = await import('xlsx');

    const workbook = xlsx.read(buffer);
    const tag: string = workbook.Props?.Keywords;
    if (tag?.length > 0) {
      cerWb.fieldMap = CerDataImportExcelReader.fieldMapGet(tag);
    }
    workbook.SheetNames.forEach(name => {
      const sheet = workbook.Sheets[name];
      const sheetData: any[] = xlsx.utils.sheet_to_json(sheet) as any[];
      const cerSheet = new CerExcelSheet(cerWb, name);
      cerSheet.rows = sheetData.map(r => new CerDataImportRow(r));
      if (cerSheet.rows.length > 0) {
        CerDataImportExcelReader.columnsGet(cerWb, cerSheet);
      }
      cerWb.sheets.push(cerSheet);
    });

    return true;
  }

  private static fieldMapGet(tag: string): Map<string, string> {
    const fieldMap = new Map<string, string>();
    tag.split(', ').forEach(t => {
      const kv = t?.split('="');
      if (kv.length == 2 && !fieldMap.has(kv[0])) {
        const name = kv[0];
        const title = kv[1].endsWith('"') ? kv[1].substring(0, kv[1].length - 1) : kv[1];
        fieldMap.set(title, name);
      }
    });
    return fieldMap;
  }

  private static columnsGet(cerWb: CerExcelWorkbook, sheet: CerExcelSheet) {
    var nextIndex: CerNextIndex = { index1: null, index2: null };
    sheet.columns = Object.keys(sheet.rows[0].rowData).map(key => new CerExcelColumn(key));
    sheet.columns.forEach(c => {
      c.name = cerWb.fieldMap?.get(c.title) ?? c.title;
      CerDataImportExcelReader.nextIndexCalc(nextIndex);
      c.index = (nextIndex.index1 != null ? String.fromCharCode(nextIndex.index1) : "") +
        String.fromCharCode(nextIndex.index2);
    });
  }

  private static nextIndexCalc(nextIndex: CerNextIndex) {
    const firstIdx: number = "A".charCodeAt(0);
    const lastIdx: number = "Z".charCodeAt(0);

    if (nextIndex.index2 == null) {
      nextIndex.index2 = firstIdx;
    }
    else if (nextIndex.index2 == lastIdx) {
      nextIndex.index1 = nextIndex.index1 == null ? firstIdx : nextIndex.index1 + 1;
      nextIndex.index2 = firstIdx;
    }
    else {
      nextIndex.index2++;
    }
  }

  private static setStatus(wb: CerExcelWorkbook) {
    // Set status
    if (wb.sheets?.length > 0) {
      wb.sheets.forEach(s => {
        wb.rowCountTotal += s.rows.length;
      });
    }
    if (wb.rowCountTotal > 0) {
      wb.status = 'ok';
      wb.statusText = 'Data er klar til import';
    }
  }
}